module.exports = __webpack_public_path__ + "605d8ef14b45de2c4a22b659fcd0e5b1.gif";